/* eslint-disable angular/no-private-call */
angular.module('tgaAdmin')
  .service('urlService', ['$location', 'envService',
    function ($location, envService) {
      const DEFAULT_PORTS = { http: 80, https: 443, ftp: 21 };
      const serverAddress = envService.read('serverAddress');
      const forceDomain = envService.read('forceDomain');
      const host = $location.host();
      let base = host;
      let domain = null;

      if (host.indexOf('.') >= 2) {
        const parts = host.split('.');
        domain = parts.shift();
        base = parts.join('.');
      }

      if (forceDomain) {
        domain = forceDomain;
      }

      // Composes a protocol, host, and port into a URL prefix, i.e. 'https://hostname:8443/'
      // Omits the port portion when the port is a default.
      function composeProtocolHostPort(protocol, h, p) {
        // If passed zero arguments, use $location
        if (protocol == null) {
          protocol = $location;
        }

        // If passed a LocationHashbangUrl (like $location), use it
        // eslint-disable-next-line no-prototype-builtins
        if (protocol.hasOwnProperty('$$protocol')) {
          const input = protocol;
          protocol = input.$$protocol;
          h = input.$$host;
          p = input.$$port;
        }

        // Construct the URL
        return `${protocol}://${host}${p === DEFAULT_PORTS[protocol] ? '' : `:${p}`}`;
      }

      return ({
        api: serverAddress,
        base,
        domain,
        composeProtocolHostPort,
      });
    },
  ]);
